module.exports = __webpack_public_path__ + "img/15.315bb5dc.png";